import React, { useState, useEffect, useRef } from "react";
import { Box, Flex, Button } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import { safeEval } from "utils/helpers";
import get from "lodash/get";
import Spinner, { styles } from "components/Spinner";
import { setData, getJumioVerificationFulfillmentUrl } from "ducks/actions/index";
import { useDispatch } from "react-redux";
import { buildJumioAuthHeaders, buildJumioParams } from "utils/helpers";
import { paths } from "utils/constants";

const TimedMessageButton = ({ data = {}, messageData, ...props }) => {
  const { delayed, btnLabel, msg, msgBtn, style } = data;
  const btnState = delayed ? false : true;
  const [showMainBtn, setShowMainButton] = useState(btnState);
  const isJumioFulFilementAPI = get(props, "appSettings.enable_jumio_fulfillment_flow", false);
  const [isMsgBtnLinkLoading, setIsMsgBtnLinkLoading] = useState(!isJumioFulFilementAPI);
  const [showMsg, setShowMsg] = useState(
    get(props, "ekycValidation.showMsgEkycValidationFailure", false)
  );
  const msgBtnEnabled = get(msgBtn, "enabled", false);
  const msgBtnLink = get(msgBtn, "link", null);
  const msgBtnLabel = get(msgBtn, "label", "");
  let msgBtnLinkRef = useRef(
    safeEval(get, get(props, "formValues"), msgBtnLink, null, props)
  );
  // console.log("AAAA 11Props :::", props);

  // console.log("AAAA Props :::", isJumioFulFilementAPI);
  const dispatch = useDispatch();

  useEffect(() => {
    if (msgBtnLinkRef)
      msgBtnLinkRef.current = safeEval(
        get,
        get(props, "formValues"),
        msgBtnLink,
        null,
        props
      );
    if (msgBtnLinkRef.current) {
      setIsMsgBtnLinkLoading(false);
    } else {
      !isJumioFulFilementAPI && setIsMsgBtnLinkLoading(true);
    }
  }, [props, msgBtnLink, isJumioFulFilementAPI]);

  const onClickMainBtn = () => {
    setShowMsg(true);
    dispatch(setData({ key: "MyInfoTroubleEvent" }));
  };
  const onClickMessageBtn = async () => {

    if (!isJumioFulFilementAPI) {
      return (window.location = msgBtnLinkRef.current);
    } else {
      // console.log("AAAA Props :::", props);
      const jumioSessionToken = get(props, "jumioSessionToken", null);
      // console.log("AAAA jumioSessionToken :::", jumioSessionToken);
      const sessionToken = window.sessionStorage.getItem("sessionToken");
      try {
        const headers = buildJumioAuthHeaders(jumioSessionToken);
        const params = buildJumioParams(
          sessionToken,
          paths.PERSONAL_DETAILS,
          paths.EKYC,
          isJumioFulFilementAPI
        );
        setIsMsgBtnLinkLoading(true);
        await dispatch(getJumioVerificationFulfillmentUrl(
          headers,
          params,
          (response) => {
            const link = response.redirectUrl;
            if (link) {
              window.location.assign(link);
            }
            // console.log("AAAA1 :::", link);
          }
        ));
      } catch (err) {
        console.error("API Error", err);
      }
    }


    // return (window.location = msgBtnLinkRef.current);
  };

  !showMainBtn &&
    setTimeout(() => {
      setShowMainButton(true);
      console.log(delayed);
    }, delayed);

  return (
    <>
      {showMainBtn && (
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
          style={{ ...style }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Button
              as="a"
              onClick={onClickMainBtn}
              sx={{
                background: "none",
                backgroundColor: "transparent!important",
                border: "none",
                padding: 0,
                color: "cta.color",
                textDecoration: "underline",
                cursor: "pointer"
              }}
            >
              <FormattedMessage html id={btnLabel} values={messageData} />
            </Button>
          </Box>
          {showMsg && (
            <>
              <Box pt={3} pb={3}>
                <FormattedMessage html id={msg} values={messageData} />
              </Box>
              {msgBtnEnabled && (
                <Box>
                  <Button
                    variant="outline"
                    onClick={onClickMessageBtn}
                    disabled={isMsgBtnLinkLoading}
                  >
                    {isMsgBtnLinkLoading ? (
                      <Spinner size={10} sx={styles.inlineMessage} />
                    ) : (
                      <FormattedMessage
                        html
                        id={msgBtnLabel}
                        values={messageData}
                      />
                    )}
                  </Button>
                </Box>
              )}
            </>
          )}
        </Flex>
      )}
    </>
  );
};

export default TimedMessageButton;
